module.exports = __webpack_public_path__ + "img/icon_lastname.e5a4f65c.png";